import React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import LogoSmall from 'assets/images/baemingo_logo_small.svg';
import LogoImage from 'assets/images/baemingo_logo_white.svg';
import Select from 'Components-redesign/Fields/New/Select';

export const Wrapper = styled.div`
  background-color: var(--colorBlueGray1300);
  height: 80px;
  position: fixed;
  left: 0;
  z-index: 1998;
  width: 100%;
  top: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  align-items: center;
  padding: 4px 24px;
  max-width: 100vw;

  @media (max-width: 680px) {
    padding: 4px 16px;
  }
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CompanyWrapper = styled.div`
  padding-left: 0;

  @media (max-width: 680px) {
    input {
      padding: 4px 8px;
      height: 32px;
      font-size: 14px;
    }
  }
`;

export const RightWrapper = styled(LeftWrapper)`
  justify-content: space-between;
  align-items: center;
  min-width: 350px;

  @media (max-width: 680px) {
    height: 100%;
    min-width: auto;
  }
`;

export const Logo = styled(Link)`
  background-image: url('${LogoImage}');
  width: 187px;
  height: 15px;
  background-repeat: no-repeat;
  margin-right: auto;
  background-size: contain;

  @media (max-width: 800px) {
    background-image: url('${LogoSmall}');
    height: 30px;
    width: 30px;
  }
`;

export const DropWrapper = styled.div`
  @media (max-width: 680px) {
    display: none;
  }
`;

export const ErrorInfo = styled(Link)`
  position: absolute;
  top: 5px;
  right: 5px;

  button {
    padding: 0 !important;
    height: 24px !important;
    width: 24px !important;
  }
`;

export const Info = styled.div<{ isSuperAdmin?: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-end;
  margin-left: 20px;

  @media (max-width: 680px) {
    margin-left: 0;
    height: 100%;
    display: flex;
    flex-flow: ${(props) => (props.isSuperAdmin ? 'row wrap' : 'column')};
    gap: 0;
    justify-content: flex-end;
    align-items: ${(props) => (props.isSuperAdmin ? 'center' : 'flex-end')};
  }
`;

export const CompanyName = styled.span`
  color: var(--colorWhite);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 20px;
  text-align: right;

  @media (max-width: 680px) {
    font-size: 14px;
  }
`;

export const UserName = styled.span`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
  color: var(--colorBlueGray600);
  text-align: right;

  @media (max-width: 680px) {
    font-size: 12px;
    margin-left: 4px;
  }
`;

export const LanguageWrapper = styled.div<{ isSuperAdmin?: boolean }>`
  @media (max-width: 680px) {
    display: ${(props) => (props.isSuperAdmin ? 'none' : 'block')};
  }
`;

export const LanguageDropdown = styled(Select)`
  background-color: transparent;
  color: #eee;
  border: none;
  min-width: 80px;

  @media (max-width: 680px) {
    min-width: 56px;
    padding: 0;
    margin-left: 16px;
  }
`;
